import React from "react";

import { useTranslation } from "react-i18next";

import { SvgShapeDown, SvgShapeUp } from "@routes/IconeSvg";
import { Controller, useFormContext } from "react-hook-form";

import { InputGroup } from "@components/tailwindComponents";

import { parseNumberToFloat } from "@helpers/_functions";

export default function InputHoursPerWeek({ readOnly = false }) {
  const { t: translate } = useTranslation([
    "pages.employés.parcours&Certifications",
    "message"
  ]);
  const { control } = useFormContext();

  function onUpClicked(value, onChange) {
    value = Number.parseInt(value) || 0;
    onChange(value + 1);
  }

  function onDownClicked(value, onChange) {
    value = Number.parseInt(value) || 0;
    const nextValue = value > 0 ? value - 1 : 0;
    onChange(nextValue);
  }

  return (
    <Controller
      control={control}
      name="hoursPerWeek"
      defaultValue={0}
      render={({ field: { onChange, value, name } }) => (
        <div className="blackSvgColor arh-mb-3">
          <InputGroup
            name={name}
            value={value || ""}
            onChange={(event) => {
              const nextValue = parseNumberToFloat(event.target.value);
              onChange(nextValue);
            }}
            disabled={readOnly}
            placeholder={translate("Heures par semaine")}
            label={translate("Heures par semaine")}
            classParent="arh-w-full"
            classContent="arh-h-11 arh-w-11"
            content={
              <div className="arh-absolute arh-top-1/2 -arh-translate-y-1/2 arh-space-y-2">
                <div
                  onClick={() => {
                    if (!readOnly) {
                      onUpClicked(value, onChange);
                    }
                  }}
                  className="arh-cursor-pointer"
                >
                  {SvgShapeUp()}
                </div>
                <div
                  onClick={() => {
                    if (!readOnly) {
                      onDownClicked(value, onChange);
                    }
                  }}
                  className="arh-cursor-pointer"
                >
                  {SvgShapeDown()}
                </div>
              </div>
            }
          />
        </div>
      )}
    />
  );
}
